import React from 'react';
import { Layout, Dropdown, Avatar, Space } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { authService } from '../../services/auth';
import ThemeSwitcher from '../ThemeSwitcher';
import { useTheme } from '../../contexts/ThemeContext';

const { Header: AntHeader } = Layout;

const Header = ({ extra }) => {
  const { isDark } = useTheme();

  const handleLogout = () => {
    authService.logout();
  };

  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  const textColor = isDark ? 'rgba(255, 255, 255, 0.88)' : 'rgba(0, 0, 0, 0.88)';

  const headerStyle = {
    background: isDark ? '#141414' : '#fff',
    padding: '0 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${isDark ? '#303030' : '#f0f0f0'}`,
    transition: 'background-color var(--transition-normal), border-color var(--transition-normal)',
  };

  const titleStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    color: textColor,
    transition: 'color var(--transition-normal)',
  };

  return (
    <AntHeader style={headerStyle}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {extra}
        <span style={titleStyle}>YQ Admin</span>
      </div>
      <Space size="middle">
        <ThemeSwitcher />
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <Avatar icon={<UserOutlined />} />
            <span style={{ color: textColor }}>{'管理员'}</span>
          </Space>
        </Dropdown>
      </Space>
    </AntHeader>
  );
};

export default Header;
